<script lang="ts">
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 18 18">
	<g>
		<path
			d="M476.333 278.005a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm4.131 13.119a.36.36 0 0 1-.509 0l-3.621-3.611-3.611 3.621a.36.36 0 1 1-.51-.508l3.611-3.621-3.621-3.611a.36.36 0 1 1 .508-.51l3.621 3.611 3.611-3.622a.36.36 0 0 1 .51.508L476.842 287l3.621 3.611a.36.36 0 0 1 .001.513z"
			style="fill:#fff"
			transform="translate(-467.333 -278.005)" />
	</g>
</svg>

<style lang="scss">
</style>
